import removeIeFormElement from '../util/removeIeFormElement';
import PreApprovalChecklistForm from '../svelte/PreApprovalChecklistForm.svelte';

export default {
  init() {
    // remove IE Pre-Approval Checklist form
    removeIeFormElement('#getting-pre-approved-form-ie');

    // for accessing localized variables from PHP
    const sanctum = window.sanctum;

    // instantiate Svelte component
    new PreApprovalChecklistForm({
      target: document.querySelector('#pre-approval-checklist-form'),
      props: {
        // account, campaign prefix, sourceName, & company are used in LoanForce API call to create contact
        account: sanctum.account,
        campaignPrefix: sanctum.campaign_prefix,
        sourceName: sanctum.source_name,
        // company name displayed in disclaimer text below form
        company: sanctum.company,
        // completing the form gives user access to Pre-Approval Checklist PDF
        preApprovalChecklistUrl: sanctum.preapproval_checklist_url,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/gettingPreApproved.js